"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitListList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const wagmi_1 = require("wagmi");
const mui_form_search_1 = require("@dzambalaorg/mui-form-search");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const mui_dialog_delete_1 = require("@dzambalaorg/mui-dialog-delete");
const draft_js_utils_1 = require("@dzambalaorg/draft-js-utils");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const provider_user_1 = require("@dzambalaorg/provider-user");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const buttons_1 = require("../../../../../buttons");
const wrappers_1 = require("../../../../../wrappers");
const types_2 = require("../../../../../types");
const dialogs_1 = require("../../../../../dialogs");
const validation_1 = require("./form/validation");
const schemas_1 = require("./schemas");
const WAIT_LIST_LIST_URL = "/wait-list/list";
const emptyValues = {
    title: "",
    description: draft_js_utils_1.emptyStateString,
    item: (0, mui_inputs_asset_1.getEmptyTemplate)(types_1.TokenType.ERC20),
    isPrivate: false,
};
const WaitListList = (props) => {
    const { service } = props;
    const { profile } = (0, provider_user_1.useUser)();
    const initialSearchValues = (0, react_1.useMemo)(() => {
        return {
            ...(service === types_2.ServiceType.OFFICE && { merchantId: profile.merchantId }),
        };
    }, [service, profile]);
    const isMd = (0, material_1.useMediaQuery)(theme => theme.breakpoints.down("md"));
    const { data, isLoading, isError, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount, refetch } = (0, react_hooks_1.useFetchQuery)(WAIT_LIST_LIST_URL, { enableInfiniteScroll: isMd }, void 0, initialSearchValues);
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const { handleDelete } = (0, react_hooks_1.useDialogDelete)();
    const { address: account = "" } = (0, wagmi_1.useAccount)();
    const waitlistListCreate = () => {
        openDialog(dialogs_1.GlobalDialogKeys.WAITLIST_LIST_CREATE, emptyValues, {
            refetch,
            initialValues: emptyValues,
            message: "dialogs.create",
            testId: "WaitlistListDialogForm",
            url: WAIT_LIST_LIST_URL,
            validationSchema: validation_1.waitlistListValidationSchema,
            filter: schemas_1.waitlistListCreateFilter,
            componentNeedsOpen: true,
            componentProps: {
                mode: "create",
            },
        });
    };
    const waitlistListEdit = (waitListList) => () => {
        openDialog(dialogs_1.GlobalDialogKeys.WAITLIST_LIST_EDIT, waitListList, {
            refetch,
            initialValues: waitListList,
            message: "dialogs.edit",
            testId: "WaitlistListDialogForm",
            url: `${WAIT_LIST_LIST_URL}/${waitListList.id}`,
            validationSchema: validation_1.waitlistListValidationSchema,
            filter: schemas_1.waitlistListEditFilter,
            prepareInitialValues: schemas_1.prepareWaitlistListInitialValues,
            componentNeedsOpen: true,
            componentProps: {
                mode: "edit",
            },
        });
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(mui_page_layout_1.Breadcrumbs, { path: ["dashboard", "wait-list", "wait-list.list"] }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.PageHeader, { message: "pages.wait-list.list.title", children: (0, jsx_runtime_1.jsx)(ui_kit_1.Button, { intent: "secondary", startIcon: (0, jsx_runtime_1.jsx)(icons_material_1.Add, {}), onClick: waitlistListCreate, "data-testid": "WaitListListCreateButton", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "form.buttons.create" }) }) }), (0, jsx_runtime_1.jsx)(mui_form_search_1.SearchWithFilters, { initialValues: initialSearchValues, endAdornmentIcon: null }), (0, jsx_runtime_1.jsx)(wrappers_1.WithCheckPermissionsListWrapper, { isLoading: !data && isLoading, isError: !data && isError, isEmpty: allRows.length === 0, count: allRows.length, children: allRows.map(waitListList => ((0, jsx_runtime_1.jsxs)(styled_1.ListItem, { account: account, contract: waitListList.contract, children: [(0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { children: waitListList.title }), (0, jsx_runtime_1.jsxs)(styled_1.ListActions, { dataTestId: "WaitListActionsMenuButton", children: [(0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: waitlistListEdit(waitListList), message: "form.buttons.edit", dataTestId: "WaitListEditButton", icon: icons_material_1.Create }), (0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleDelete(waitListList), message: "form.buttons.delete", dataTestId: "WaitListDeleteButton", icon: icons_material_1.Delete }), (0, jsx_runtime_1.jsx)(buttons_1.WaitListItemCreateButton, { waitListList: waitListList, onRefreshPage: refetch }), (0, jsx_runtime_1.jsx)(buttons_1.WaitListListUploadButton, { waitListList: waitListList, onRefreshPage: refetch }), (0, jsx_runtime_1.jsx)(buttons_1.WaitListListGenerateButton, { waitListList: waitListList, onRefreshPage: refetch })] })] }, waitListList.id))) }), !isMd && totalCount > take && ((0, jsx_runtime_1.jsx)(styled_1.StyledPagination, { shape: "rounded", page: skip / take + 1, count: Math.ceil(totalCount / take), onChange: onChangePage })), isMd && hasNextPage && (0, jsx_runtime_1.jsx)("div", { ref: loadMoreRef, style: { height: "20px", margin: "20px 0" } }), (0, jsx_runtime_1.jsx)(mui_dialog_delete_1.DeleteDialog, { url: WAIT_LIST_LIST_URL, refetch: refetch })] }));
};
exports.WaitListList = WaitListList;
//# sourceMappingURL=index.js.map